import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AgGridModule } from 'ag-grid-angular';

import { BomLegendComponent } from './bom-legend.component';
import { MaterialDesignationCellRendererComponent } from './material-designation-cell-renderer/material-designation-cell-renderer.component';

@NgModule({
  declarations: [BomLegendComponent, MaterialDesignationCellRendererComponent],
  imports: [CommonModule, AgGridModule],
  exports: [BomLegendComponent],
})
export class BomLegendModule {}
